import { v4 } from "uuid";
import { IResponseEventsLog } from "../../../dashboard/tabs/scheme/components/events-train/interfaces";
import { IEventLog } from "./table";
import { IGetEventTypeProps } from "../../../../utils/event";

interface ITransformEventsDeps {
  formatDate: (date: string) => string;
  formatMessage: (descriptor: { id: string }) => string;
  getEventType: (params: IGetEventTypeProps) => string;
  getMessage: (item: IResponseEventsLog) => string;
}

export const mapEventsToGroupedLogs = (json: IResponseEventsLog[] | null, deps: ITransformEventsDeps): IEventLog[] => {
  if (!json?.length) return [];

  const { formatDate, formatMessage, getEventType, getMessage } = deps;

  const groups: Record<string, IEventLog> = {};

  json.forEach(item => {
    const formattedItemDate = formatDate(item.EventLogDate);
    const key = `${item.EventLogDate}_${item.TrainPosition}_${item.DataAlarmStatus}`;

    if (!groups[key]) {
      groups[key] = {
        id: v4(),
        status: item.DataAlarmStatus,
        position: item.TrainPosition,
        rank: item.EquipmentGroupName,
        date: formattedItemDate,
        messages: [],
      };
    }

    groups[key].messages.push({
      idEvent: item.idEvent,
      ackStatus: item.Flags ?? 0,
      status: item.DataAlarmStatus,
      type: getEventType({
        type: item.EventType,
        subType: item.EventSubType,
      }),
      pointName: item.PointName ?? "-",
      date: formattedItemDate,
      parameter:
        typeof item.MeasureType === "number"
          ? formatMessage({
              id: `pages.journals.popup.train.points.${item.MeasureType}`,
            })
          : "",
      source: "",
      fullName: item.UserLogin ?? "",
      message: getMessage(item),
      defect: "",
    });
  });

  return Object.values(groups);
};
